export class String {
  public static isNullOrEmpty(value: any): boolean {
    return !value;
  }

  public static Empty: string = '';
}
